export default __webpack_public_path__ + "static/media/holiday3.5d55a0df.jpeg";